import type { ChatRoom, ChatWithRelations, NewChat } from "@ch/generated";
import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useContext,
} from "react";
import type { ChatSocket } from "../sockets/chatSocket";

interface IChatSocketContext {
  chatSocket: ChatSocket;
  incoming: ChatWithRelations | undefined;
  incomingReadMessage: ChatWithRelations | undefined;
  setIncomingReadMessage: React.Dispatch<
    React.SetStateAction<ChatWithRelations | undefined>
  >;
  setIncoming: Dispatch<SetStateAction<ChatWithRelations | undefined>>;
  setActiveChatRoom: Dispatch<SetStateAction<ChatRoom | null>>;
  activeChatRoom: ChatRoom | null;
  goOffline: () => void;
  goOnline: () => void;
  handleJoinRooms: (val: string[]) => void;
  sendNewChat: (chat: NewChat) => void;
  readChatMessage: (data: { userId?: string; chatId: string }) => void;
  createChatroom: (chatroom: ChatRoom) => void;
}

export const ChatSocketContext = createContext<IChatSocketContext | null>(null);

export function useChatSocketContext() {
  const context = useContext(ChatSocketContext);
  if (!context) {
    throw new Error(
      "useChatSocketContext must be used within a ChatSocketProvider",
    );
  }
  return context;
}
